export type SearchParamConfig = {
  chainId: string
  tgError: string
}

export const SEARCH_PARAMS: SearchParamConfig = {
  chainId: 'chain',
  tgError: 'tgError',
}
